import React from 'react';
import { Box, Grid } from '@mui/material';
import { claimHeaders } from '@/components/ClaimDetailField/data';
import { ClaimDetailField } from '@/components/ClaimDetailField';

export const ClaimDetailsTab = () => {
	return (
		<Grid container rowSpacing={2} columnSpacing={3}>
			{Object.entries(claimHeaders).map(([key, header]) => (
				<Grid
					size={{
						xs: 12,
						sm: key === 'Description' || key === 'PaidAmount' ? 12 : 6,
					}}
					key={`detail-entry-${key}`}
				>
					<ClaimDetailField title={header} header={key} />
				</Grid>
			))}
		</Grid>
	);
};
ClaimDetailsTab.displayName = 'ClaimDetailsTab';
